import React from 'react'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useInterpolations } from '../../../utils/interpolations/interpolations'
import { useTemplate } from './_load/TemplateLoader'
import DocumentEditor from '../../../packages/kiti-editor/components/document/DocumentEditor'

const Editor = () => {
  const template = useTemplate()
  const { form, handleChange } = useFormState()
  const interpolations = useInterpolations(template.entity, template.checklistId, template.placeType, {
    block_as_table: true,
    interpolation_as_image: true
  })

  return <DocumentEditor value={form.content} onChange={handleChange('content')} interpolations={interpolations} />
}

export default Editor
